module.exports = __webpack_public_path__ + "static/trumpet_en-b20cc13cae9fda51d4d1c09774b446ad.pdf";